export enum LoanApplicationLocalStorageKeys {
  LOAN_APPLICATION_SUBMISSION_METHOD = 'loanApplicationSubmissionMethod',
}
